import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

import { UserSearchResponse } from 'utils/api/modules/user/user.types';

import AutocompleteMention from 'ui/AddCommentActivities/AutocompleteMention';

import { MentionDropdown } from './styles';

export interface MentionListRef {
  onKeyDown: (props: { event: KeyboardEvent }) => boolean;
}

export interface MentionListProps {
  items: UserSearchResponse[];
  loading?: boolean;
  command: (item: { id: string; label: string }) => void;
}

const MentionList = forwardRef<MentionListRef, MentionListProps>(({ items, loading = false, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectedIndexRef = useRef(0);
  selectedIndexRef.current = selectedIndex;

  useEffect(() => setSelectedIndex(0), [items]);

  const selectItem = (index: number): void => {
    const item = items[index];
    if (item) {
      command({ id: item.uuid, label: item.name });
    }
  };

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (items.length === 0) {
        return false;
      }
      if (event.key === 'ArrowUp') {
        setSelectedIndex((prev) => (prev + items.length - 1) % items.length);
        return true;
      }
      if (event.key === 'ArrowDown') {
        setSelectedIndex((prev) => (prev + 1) % items.length);
        return true;
      }
      if (event.key === 'Enter') {
        selectItem(selectedIndexRef.current);
        return true;
      }
      return false;
    },
  }));

  return (
    <MentionDropdown onMouseDown={(e) => e.preventDefault()}>
      <AutocompleteMention users={items} selected={selectedIndex} loading={loading} onSelectedUser={selectItem} />
    </MentionDropdown>
  );
});

MentionList.displayName = 'MentionList';

export default MentionList;
